import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3075cfa8")

_pushScopeId("data-v-3075cfa8")
const _hoisted_1 = { class: "businessClients-sticky-summary-wrapper" }
const _hoisted_2 = { class: "sticky-summary-wrapper-row" }
const _hoisted_3 = { class: "wrapper-row-item" }
const _hoisted_4 = { class: "wrapper-row-item" }
const _hoisted_5 = { class: "wrapper-row-item" }
const _hoisted_6 = { class: "wrapper-row-item" }
const _hoisted_7 = { class: "wrapper-row-item" }
const _hoisted_8 = { class: "wrapper-row-item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["businessClients-sticky-summary-wrapper-template", { hideMobile: _ctx.hideMobile }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('businessClients.footer.amount-orders')), 1),
          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(_ctx.amountOrder)) + " " + _toDisplayString(_ctx.currencySign), 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('businessClients.footer.total-invoice')), 1),
          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(_ctx.totalInvoices)) + " " + _toDisplayString(_ctx.currencySign), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('businessClients.footer.total-receipts')), 1),
          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(_ctx.totalAllReceipts)) + " " + _toDisplayString(_ctx.currencySign), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('businessClients.footer.total-binded-receipts')), 1),
          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(_ctx.totalBindedReceipts)) + " " + _toDisplayString(_ctx.currencySign), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('businessClients.footer.total-invoices-left-to-bind')), 1),
          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(_ctx.totaInvoiceslLeftToBind)) + " " + _toDisplayString(_ctx.currencySign), 1)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('orders.balance')), 1),
          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(_ctx.balance)) + " " + _toDisplayString(_ctx.currencySign), 1)
        ])
      ])
    ])
  ], 2))
})